export default __webpack_public_path__ + "static/media/riso-12.fc1bb051.jpg";